/**
 * Эта штука будет делать нам объекты из 2 массивов, пока Даня не сделает объекты на бэке
 * @param tables - tables
 * @param order - order array

 */

interface ISection {
    id: number
    filter: any
    columns: string
    width: number
    height: number
}


const tablesSortWrapper = (tables: any[], order?: number[]) => {
    if (!tables.length) {
        return tables;
    }
    if (order && Array.isArray(order)) {
        const new_arr = tables.sort((a, b) => {
            return order.indexOf(a.id) - order.indexOf(b.id);
        });
        return new_arr;
    }
    return tables;
}
export default tablesSortWrapper
